// extracted by mini-css-extract-plugin
module.exports = {"address":"_200HsE5g"};